<template>
  <svg viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path d="M6.25 10.125H11.25V11.25H6.25V10.125ZM6.25 7.3125H13.75V8.4375H6.25V7.3125ZM6.25 12.9375H9.375V14.0625H6.25V12.9375Z" :class="containerClass" />
    <path
      d="M15.625 2.8125H13.75V2.25C13.75 1.95163 13.6183 1.66548 13.3839 1.4545C13.1495 1.24353 12.8315 1.125 12.5 1.125H7.5C7.16848 1.125 6.85054 1.24353 6.61612 1.4545C6.3817 1.66548 6.25 1.95163 6.25 2.25V2.8125H4.375C4.04348 2.8125 3.72554 2.93103 3.49112 3.142C3.2567 3.35298 3.125 3.63913 3.125 3.9375V15.75C3.125 16.0484 3.2567 16.3345 3.49112 16.5455C3.72554 16.7565 4.04348 16.875 4.375 16.875H15.625C15.9565 16.875 16.2745 16.7565 16.5089 16.5455C16.7433 16.3345 16.875 16.0484 16.875 15.75V3.9375C16.875 3.63913 16.7433 3.35298 16.5089 3.142C16.2745 2.93103 15.9565 2.8125 15.625 2.8125ZM7.5 2.25H12.5V4.5H7.5V2.25ZM15.625 15.75H4.375V3.9375H6.25V5.625H13.75V3.9375H15.625V15.75Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
